<template>
  <el-select v-model="val"
             :size='size'
             :style='cssStyle'
             :multiple="multiple"
             :placeholder="placeholder"
             :clearable="clearable"
             :filterable="filterable"
             :disabled="disabled"
             :allow-create="allowCreate"
             @change="change"
             @clear="change">
    <el-option
      v-for="item in items"
      :key="item[valueAttr]"
      :label="item[labelAttr]"
      :value="item[valueAttr]"
      :disabled="item.disabled">
      <slot :item="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    multiple: {
      default: false
    },
    placeholder: {
      default: ''
    },
    clearable: {
      default: true
    },
    filterable: {
      default: true
    },
    disabled: {
      default: false
    },
    options: {},
    labelAttr: {
      default: "name"
    },
    valueAttr: {
      default: "id"
    },
    allowCreate: {
      default: false
    },
    value: {},
  },
  data() {
    return {
      val: this.value,
      items: this.options || []
    }
  },
  watch: {
    value: function(value) {
      if(this.multiple) {
        this.val = value || [];
      } else {
        this.val = value || '';
      }
    },
    options: function(options) {
      this.items = options;
    },
  },
  methods: {
    change(val) {
      if(this.multiple) {
        this.$emit('change', (val || []), this.items);
      } else {
        this.$emit('change', (val || ''), this.items);
      }
    }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxSelect.vue